import React from 'react';

import { Flex, Spin } from 'antd';

import { useLocalSelector } from '@app/services/hooks/useRedux';
import { AccessDenied } from '@components/AccessDenied';

interface IProps {
  children: React.ReactNode;
}

export const OrdersAccess: React.FC<IProps> = ({ children }) => {
  const ordersContext = useLocalSelector((state) => state.currentSession.ordersContext);

  if (!ordersContext) {
    return (
      <Flex justify="center" style={{ padding: 48 }}>
        <Spin />
      </Flex>
    );
  }
  if (!ordersContext.scope?.$permissions?.view_counterparty_orders) {
    return <AccessDenied />;
  }

  return <>{children}</>;
};
